<div>
    <label class="toggle-switch modifier-class clearfix">
        <span class="toggle-switch-label left font-size--1">{{ toggleLabel }}</span>
        <input type="checkbox" class="toggle-switch-input" [(ngModel)]="toggleValue" (ngModelChange)="onToggleChange()">
        <span class="toggle-switch-track right"></span>
    </label>
</div>
